export const videoUploadStatus = {
  NOT_STARTED: 0,
  PENDING: 1,
  CANCELLED: 2,
  COMPLETED: 3,
};
